import { Button, ButtonVariant } from 'components/UI/Button/Button';
import Modal from 'components/UI/Modal/Modal';
import React from 'react';
import classes from './PromptModal.module.scss';

interface PromptModalProps {
    open: boolean;
    title: string;
    description: React.ReactNode;
    confirmLabel?: string;
    confirmVariant?: ButtonVariant;
    onConfirm: () => void;
    onCancel: () => void;
}

export const PromptModal: React.FC<PromptModalProps> = ({
    open,
    title,
    description,
    confirmLabel = 'Yes',
    confirmVariant = 'destructive',
    onConfirm,
    onCancel
}) => {
    return (
        <Modal
            open={open}
            className={classes.root}
            bodyClassName={classes.body}
            headerClassName={classes.header}
            footerClassName={classes.footer}
            footer={
                <>
                    <Button variant="black" onClick={onCancel}>
                        No
                    </Button>
                    <Button variant={confirmVariant} onClick={onConfirm}>
                        {confirmLabel}
                    </Button>
                </>
            }
            onClose={onCancel}
        >
            <p className="h3">{title}</p>
            <p>{description}</p>
        </Modal>
    );
};
